"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _shareGroup = _interopRequireDefault(require("./share-group"));

var _socialIcon = _interopRequireDefault(require("./social-icon"));

var _reactUtils = require("../react-utils");

require("./share-widget.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Standard component for displaying share options on content pages. This is
 * intended for use on pages that target users high in the purchase funnel and
 * existing customers who may share content to their social networks,
 * promoting Glowforge. Deeper in the funnel, emphasis should be placed on
 * a purchase-related call to action instead of social.
 *
 * This component delegates rendering of individual ShareButtons to ShareGroup.
 *
 * @type {{[p: string]: *}} sites - passed on to ShareGroup - ordered list of social sites
 * @param pageTitle - the title of the page to be shared e.g. `document.title`
 * @param expandDirection - left | right - the side on which the ShareGroup appears
 * @param url - passed on to ShareButton - the canonical url of the content being shared
 * @param hashtag - passed on to ShareButton - do not include the # character e.g. 'glowforge'
 * @param text - passed on to ShareButton - the primary short-text to pre-populate share content
 * @param quote - passed on to ShareButton - a quote from Glowforge to include alongside the url
 * @param image - passed on to ShareButton - an image to share (only supported by pinterest)
 * @param props.size - passed on to SocialIcon - standard sizes small, medium, or large
 * @param props.appearance - passed on to SocialIcon - available styles square, round, clear
 */
var ShareWidget = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ShareWidget, _React$PureComponent);

  var _super = _createSuper(ShareWidget);

  function ShareWidget(props) {
    var _this;

    _classCallCheck(this, ShareWidget);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "mouseIn", function () {
      _this.setState({
        showFlyout: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "mouseOut", function () {
      _this.setState({
        showFlyout: false
      });
    });

    _this.state = {
      showFlyout: false
    };
    return _this;
  }

  _createClass(ShareWidget, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          pageTitle = _this$props.pageTitle,
          expandDirection = _this$props.expandDirection,
          childProps = _objectWithoutProperties(_this$props, ["className", "pageTitle", "expandDirection"]);

      var showFlyout = this.state.showFlyout;
      var flyout = (0, _reactUtils.includeWhen)(showFlyout, function () {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "flyout"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "pageTitle"
        }, pageTitle), /*#__PURE__*/_react["default"].createElement("div", {
          className: "buttons"
        }, /*#__PURE__*/_react["default"].createElement(_shareGroup["default"], _extends({
          size: "small"
        }, childProps))));
      });
      var wrapperClasses = (0, _classnames["default"])(['ShareWidget', expandDirection, className], {
        active: showFlyout
      });
      var shareIcon = showFlyout ? 'share' : 'shareLight';
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: wrapperClasses,
        onMouseEnter: this.mouseIn,
        onMouseLeave: this.mouseOut
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "inlineWrapper"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "shareTrigger"
      }, /*#__PURE__*/_react["default"].createElement(_socialIcon["default"], {
        site: shareIcon,
        appearance: "clear",
        size: "fit"
      })), flyout));
    }
  }], [{
    key: "documentTitle",
    value: function documentTitle() {
      if (typeof window === 'undefined') {
        return null;
      }

      return _lodash["default"].get(window, ['document', 'title']);
    }
  }]);

  return ShareWidget;
}(_react["default"].PureComponent);

_defineProperty(ShareWidget, "propTypes", _objectSpread(_objectSpread({}, _shareGroup["default"].propTypes), {}, {
  className: _propTypes["default"].string,
  pageTitle: _propTypes["default"].string,
  expandDirection: _propTypes["default"].oneOf(['left', 'right'])
}));

_defineProperty(ShareWidget, "defaultProps", {
  className: null,
  expandDirection: 'right',
  pageTitle: ShareWidget.documentTitle() || 'Glowforge',
  // eslint-disable-next-line react/default-props-match-prop-types
  url: undefined
});

var _default = ShareWidget;
exports["default"] = _default;